module.exports = __webpack_public_path__ + "assets/img/2.f385d2ae.png";